import { Injectable } from '@angular/core';

import {apiName, bombaAuditoriaApiName} from "./data.service";
import { RestService } from "../../../core/services/rest.service";
import {Bomba, Hidrometro} from "./bomba.model";

@Injectable()
export class BombaApiService {

    constructor(
        private _restService: RestService
    ) { }

    onPost(object: Bomba, done: any) {
        this._restService.onPost(apiName, object, done);
    }

    onPut(object: Bomba, done: any) {
        this._restService.onPut(apiName, object, done);
    }

    onDelete(objectId: number, done: any) {
        this._restService.onDelete(apiName, objectId, done);
    }

    onGetAll(done: any) {
        let filter: any = {"order":"nome","include":[{"tanque": ["combustivel"]}]};
        this._restService.onGetPost(apiName, filter, done);
    }

    onGetById(objectId: number, done: any) {
        let filter: any = {"include":[{"tanque": ["combustivel"]}]};
        this._restService.onGetPostId(apiName, objectId, filter, done);
    }

    onGetByTanque(tanqueId: number, done: any) {
        let filter: any = {"include":[{"tanque": ["combustivel"]}],"where":{"tanqueId":tanqueId}};
        this._restService.onGetPost(apiName, filter, done);
    }

    onGetMovimentacao(objectId: number, ano: number, mes: number, done: any) {
        this._restService.onGet(apiName + '/relatorio/bomba/'+ objectId + '/mes/' + mes + '/ano/' + ano, done);
    }

    onGetApiUrl() {
        return apiName;
    }

    //auditoria
    onGetHidrometroByBomba(bombaId: number, done: any) {
        let filter: any = {"where":{"bombaId":bombaId},"order":"data DESC"};
        this._restService.onGetPost(bombaAuditoriaApiName, filter, done);
    }

    onPostHidrometro(object: Hidrometro, done: any) {
        this._restService.onPost(bombaAuditoriaApiName, object, done);
    }

    onPutHidrometro(object: Hidrometro, done: any) {
        this._restService.onPut(bombaAuditoriaApiName, object, done);
    }

    onDeleteHidrometro(objectId: number, done: any) {
        this._restService.onDelete(bombaAuditoriaApiName, objectId, done);
    }

    onPostAuditar(object: any, done: any) {
        this._restService.onGetPostCustom('auditoria/bomba', object, done);
        // {"bombaId": 1,"dataInicio": "2017-01-20T09:10:00.000Z","dataFim": "2018-12-01T09:10:00.000Z"}
    }

    onGetHidrometroVirtual(bombaId: number, done: any) {
        this._restService.onGet(bombaAuditoriaApiName + '/virtual/bomba/' + bombaId, done);
    }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/abastecimentos/bombas/shared/bomba-api.service.ts
 **/